var accessibilityHelpers = {};
accessibilityHelpers.init = function() {
    // 1. Trap focus within the drawer when it's open
    var drawer = document.querySelector('#mega-nav');
    if (!drawer) {
        return;
    }

    var firstFocusableElement = null;
    var focusTrapTarget = drawer;
    var lastNestedTrigger = null;

    function getFocusableElements(container) {
        if (!container) {
            return [];
        }

        function isElementAndAncestorsVisible(element, root) {
            var current = element;

            while (current && current.nodeType === 1) {
                if (current.hasAttribute('hidden') || current.getAttribute('aria-hidden') === 'true') {
                    return false;
                }

                var currentStyles = window.getComputedStyle(current);
                if (
                    currentStyles.display === 'none' ||
                    currentStyles.visibility === 'hidden' ||
                    currentStyles.visibility === 'collapse'
                ) {
                    return false;
                }

                if (current === root) {
                    break;
                }

                current = current.parentElement;
            }

            return true;
        }

        var focusableElements = container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

        return Array.prototype.filter.call(focusableElements, function(element) {
            return !element.hasAttribute('disabled') && isElementAndAncestorsVisible(element, container);
        });
    }

    function focusFirstElement(container) {
        if (!container) {
            return;
        }

        var focusableElements = getFocusableElements(container);
        if (!focusableElements.length) {
            return;
        }

        var firstEl = focusableElements[0];
        if (document.activeElement !== firstEl) {
            firstEl.focus();
        }
    }

    function focusLastTriggerOrDrawer(fallbackElement) {
        var focusTarget = null;

        if (lastNestedTrigger && document.contains(lastNestedTrigger)) {
            focusTarget = lastNestedTrigger;
        }

        if (!focusTarget && fallbackElement && document.contains(fallbackElement)) {
            focusTarget = fallbackElement;
            lastNestedTrigger = fallbackElement;
        }

        if (focusTarget) {
            focusTarget.focus();
        } else {
            focusFirstElement(drawer);
        }
    }

    function closeAllNestedDrawers() {
        var nestedDrawers = drawer.querySelectorAll('.drawer.drawer-nested');
        var closedAny = false;

        for (var i = 0; i < nestedDrawers.length; i++) {
            var nestedDrawer = nestedDrawers[i];
            var wasOpen = nestedDrawer.classList.contains('open');

            nestedDrawer.classList.remove('open');
            nestedDrawer.style.display = 'none';
            nestedDrawer.setAttribute('aria-hidden', 'true');

            var siblingTrigger = nestedDrawer.previousElementSibling;
            if (siblingTrigger && siblingTrigger.classList) {
                siblingTrigger.classList.remove('active');
                siblingTrigger.setAttribute('aria-expanded', 'false');
            }

            var primaryTrigger = getPrimaryTriggerFromDrawer(nestedDrawer);
            if (primaryTrigger && primaryTrigger !== siblingTrigger) {
                if (primaryTrigger.classList) {
                    primaryTrigger.classList.remove('active');
                }
                primaryTrigger.setAttribute('aria-expanded', 'false');
            }

            if (wasOpen) {
                closedAny = true;
            }
        }

        if (closedAny) {
            drawer.classList.remove('nested-drawer-active');
            lastNestedTrigger = null;
            updateFocusTrapTarget();
        }

        return closedAny;
    }

    function getPrimaryTriggerFromDrawer(nestedDrawer) {
        if (!nestedDrawer) {
            return null;
        }

        var triggerAttr = nestedDrawer.getAttribute('data-drawer-trigger');
        if (!triggerAttr) {
            return nestedDrawer.previousElementSibling;
        }

        var selectors = triggerAttr.split(',');
        if (!selectors.length) {
            return null;
        }

        var selector = selectors[0].trim();
        if (!selector) {
            return null;
        }

        try {
            return document.querySelector(selector);
        } catch (err) {
            return null;
        }
    }

    function registerNestedDrawerTriggerTracking() {
        var nestedDrawers = document.querySelectorAll('.drawer.drawer-nested');

        for (var i = 0; i < nestedDrawers.length; i++) {
            nestedDrawers[i].addEventListener('opening.komodo.drawer', function(event) {
                var targetDrawer = event.currentTarget || event.target;
                if (!targetDrawer) {
                    return;
                }

                var candidate = document.activeElement;
                if (!candidate || targetDrawer.contains(candidate)) {
                    var derived = getPrimaryTriggerFromDrawer(targetDrawer);
                    if (derived) {
                        candidate = derived;
                    }
                }

                if (candidate) {
                    lastNestedTrigger = candidate;
                }
            });
        }
    }

    function setFocusTrapTarget(target) {
        focusTrapTarget = target || drawer;
    }

    function getActiveFocusContainer() {
        if (!focusTrapTarget) {
            return drawer;
        }

        var isVisible = window.getComputedStyle(focusTrapTarget).display !== 'none';
        if (focusTrapTarget.classList && focusTrapTarget.classList.contains('open') && isVisible) {
            return focusTrapTarget;
        }

        return drawer;
    }

    function updateFocusTrapTarget() {
        var openNestedDrawer = drawer.querySelector('.drawer.drawer-nested.open');
        if (openNestedDrawer && window.getComputedStyle(openNestedDrawer).display !== 'none') {
            setFocusTrapTarget(openNestedDrawer);
            focusFirstElement(openNestedDrawer);
        } else {
            setFocusTrapTarget(null);
            focusFirstElement(drawer);
        }
    }

    function initNestedDrawerObserver() {
        if (typeof MutationObserver === 'undefined') {
            return;
        }

        var observer = new MutationObserver(function(mutationsList) {
            var shouldUpdateFocus = false;

            for (var i = 0; i < mutationsList.length; i++) {
                var mutation = mutationsList[i];
                var target = mutation.target;

                if (target === drawer && mutation.attributeName === 'class') {
                    var previousClasses = mutation.oldValue || '';
                    var wasOpen = previousClasses.indexOf('open') !== -1;
                    var isOpen = drawer.classList.contains('open');

                    if (wasOpen && !isOpen) {
                        closeAllNestedDrawers();
                        focusMenuToggleButton();
                        drawer.classList.remove('nested-drawer-active');
                        drawer.ariaHidden = "true";
                        drawer.style.display = "none";
                        continue;
                    }
                }

                if (target.classList && target.classList.contains('drawer')) {
                    shouldUpdateFocus = true;
                }
            }

            if (shouldUpdateFocus) {
                updateFocusTrapTarget();
            }
        });

        observer.observe(drawer, {
            attributes: true,
            subtree: true,
            attributeFilter: ['class', 'style'],
            attributeOldValue: true
        });
    }

    drawer.addEventListener('keydown', function(e) {
        if (e.key === 'Tab' || e.keyCode === 9) {
            var trapContainer = getActiveFocusContainer();
            var focusableElements = getFocusableElements(trapContainer);

            if (!focusableElements.length && trapContainer !== drawer) {
                trapContainer = drawer;
                focusableElements = getFocusableElements(trapContainer);
            }

            if (!focusableElements.length) {
                return;
            }

            var firstElement = focusableElements[0];
            var lastElement = focusableElements[focusableElements.length - 1];

            if (e.shiftKey) {
                if (document.activeElement === firstElement) {
                    lastElement.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastElement) {
                    firstElement.focus();
                    e.preventDefault();
                }
            }
        }
    });

// Function to get the appropriate initial focus element based on viewport width
    function getInitialFocusElement() {
        if (window.innerWidth > 992) {
            return drawer.querySelector('.drawer-close.close-main-drawer');
        }

        return document.querySelector('#eStoreSelect-no-desktop') || drawer.querySelector('.drawer-close.close-main-drawer');
    }

// Function to set initial focus when drawer opens
    function setInitialFocus() {
        firstFocusableElement = getInitialFocusElement();
        setTimeout(function() {
            if (firstFocusableElement) {
                firstFocusableElement.focus();
            }
        }, 500);
    }

// Add event listener for menu opening
    var menuToggleButton = document.querySelector('#open-main-drawer');
    if (menuToggleButton) {
        menuToggleButton.addEventListener('click', setInitialFocus);
    }

    function focusMenuToggleButton() {
        if (!menuToggleButton) {
            return;
        }

        lastNestedTrigger = null;
        if (document.activeElement !== menuToggleButton) {
            menuToggleButton.focus();
        }
    }

    // Footer specific accordion behavior -- Start
    var FOOTER_ACCORDION_BREAKPOINT = 992;
    var footerDiv = document.querySelector('#new-global-footer');
    var footerAccordionHeaders = footerDiv ? footerDiv.querySelectorAll('.list-title.accordion-header') : [];

    function footerAccordionsEnabled() {
        return window.innerWidth < FOOTER_ACCORDION_BREAKPOINT;
    }

    function syncFooterAccordionState(header) {
        var parentAccordion = findClosest(header, '.list-item.accordion');
        if (!parentAccordion) {
            return;
        }
        var isOpen = parentAccordion.classList.contains('open');
        header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    function refreshFooterAccordionAttributes() {
        if (!footerAccordionHeaders.length) {
            return;
        }

        var enable = footerAccordionsEnabled();
        for (var i = 0; i < footerAccordionHeaders.length; i++) {
            var header = footerAccordionHeaders[i];

            if (enable) {
                header.setAttribute('tabindex', '0');
                header.setAttribute('role', 'button');
                syncFooterAccordionState(header);
            } else {
                header.removeAttribute('tabindex');
                header.removeAttribute('role');
                header.removeAttribute('aria-expanded');
            }
        }
    }

    if (footerAccordionHeaders.length) {
        for (var i = 0; i < footerAccordionHeaders.length; i++) {
            var footerHeader = footerAccordionHeaders[i];

            footerHeader.addEventListener('click', function() {
                if (!footerAccordionsEnabled()) {
                    return;
                }

                var headerEl = this;
                setTimeout(function() {
                    syncFooterAccordionState(headerEl);
                }, 0);
            });
        }

        refreshFooterAccordionAttributes();
        window.addEventListener('resize', refreshFooterAccordionAttributes);
    }

    // Footer specific accordion behavior -- End

// Polyfill for Element.closest for IE11
    function findClosest(el, selector) {
        while (el) {
            if (el.matches(selector)) {
                return el;
            }
            el = el.parentElement;
        }
        return null;
    }

    function handleMainDrawerCloseButtons() {
        var closeButtons = drawer.querySelectorAll('.close-main-drawer');

        for (var i = 0; i < closeButtons.length; i++) {
            var button = closeButtons[i];
            if (findClosest(button, '.drawer.drawer-nested')) {
                continue;
            }

            button.addEventListener('click', function() {
                lastNestedTrigger = null;
                setTimeout(focusMenuToggleButton, 0);
            });

            button.addEventListener('keydown', function(e) {
                if ((e.key === 'Enter' || e.keyCode === 13) || (e.key === 'Space' || e.keyCode === 32)) {
                    lastNestedTrigger = null;
                    setTimeout(focusMenuToggleButton, 0);
                }
            });
        }
    }

// 3. Make child elements tabbable and functional
    var accordionBodies = document.querySelectorAll('.list-item-description.accordion-body');
    var drawerOnlyBody = document.querySelectorAll('.drawer-nested-only');

    function addEventsToMenuItems(selector) {
        for (var i = 0; i < selector.length; i++) {
            var body = selector[i];
            var childLinks = body.querySelectorAll('a, .list-item--text');
            for (var j = 0; j < childLinks.length; j++) {
                var link = childLinks[j];
                link.setAttribute('tabindex', '0');
                link.addEventListener('keydown', function(e) {
                    if ((e.key === 'Enter' || e.keyCode === 13) || (e.key === 'Space' || e.keyCode === 32)) {
                        e.preventDefault();
                        if (this.getAttribute('href')) {
                            window.location.href = this.getAttribute('href');
                        } else {
                            // Trigger click event for non-anchor elements
                            this.click();
                        }
                    }
                });
            }
        }
    }
    function closest(element, selector) {
        while (element) {
            if (element.matches(selector)) {
                return element;
            }
            element = element.parentElement;
        }
        return null;
    }
    function drawerOnlyNavs() {
        var uniqueNavs = document.querySelectorAll('.list-item:not(.accordion) > .list-item--text.drawer-only');
        let currentOpenDrawer = null;

        for (var i = 0; i < uniqueNavs.length; i++) {
            var section = uniqueNavs[i];
            section.setAttribute('tabindex', '0');
            section.setAttribute('role', 'button');
            section.setAttribute('aria-expanded', 'false');
            section.addEventListener('keydown', function(e) {
                if ((e.key === 'Enter' || e.keyCode === 13) || (e.key === 'Space' || e.keyCode === 32)) {
                    e.preventDefault();
                    toggleDrawerOnly(this);
                }
            });
        }

        function toggleDrawerOnly(section) {
            var isActive = section.classList.contains('active');
            var nestedDrawer = section.nextElementSibling;
            var megaNav = document.querySelector('#mega-nav');
            let allOpenDrawers;

            // If there's an open drawer and it's not the current one, close it
            if (currentOpenDrawer && currentOpenDrawer !== nestedDrawer) {
                closeDrawerOnly(currentOpenDrawer, { restoreFocus: false });
            }

            // Toggle active class and aria-expanded attribute
            section.classList.toggle('active');
            section.setAttribute('aria-expanded', !isActive);

            // Toggle drawer open class
            if (nestedDrawer && nestedDrawer.classList.contains('drawer-nested')) {
                nestedDrawer.classList.toggle('open');
                nestedDrawer.style.display = !isActive ? 'block' : 'none';
                nestedDrawer.setAttribute('aria-hidden', !isActive ? 'false' : 'true');
                megaNav.classList.toggle('nested-drawer-active');
                // Close all open drawers when opening a new one - this happens with accordions that have drawers
                allOpenDrawers = document.querySelectorAll('.drawer.drawer-nested.open');
                if(allOpenDrawers && allOpenDrawers.length > 1){
                    megaNav.classList.toggle('nested-drawer-active');
                    allOpenDrawers[0].classList.toggle('open');
                }
                if (!isActive) {
                    lastNestedTrigger = section;
                    currentOpenDrawer = nestedDrawer;
                } else {
                    currentOpenDrawer = null;
                }
                updateFocusTrapTarget();
                if (isActive) {
                    focusLastTriggerOrDrawer(section);
                }
            }
        }

        function closeDrawerOnly(nestedDrawer, options) {
            if (!nestedDrawer) {
                return;
            }

            var settings = options || {};
            nestedDrawer.classList.remove('open');
            nestedDrawer.style.display = 'none';
            nestedDrawer.setAttribute('aria-hidden', 'true');
            var section = nestedDrawer.previousElementSibling;
            if (section) {
                section.classList.remove('active');
                section.setAttribute('aria-expanded', 'false');
            }
            currentOpenDrawer = null;
            updateFocusTrapTarget();
            if (settings.restoreFocus !== false) {
                focusLastTriggerOrDrawer(getPrimaryTriggerFromDrawer(nestedDrawer));
            }
        }

        // Close drawer when clicking outside
        document.addEventListener('click', function(event) {
            if (currentOpenDrawer && !currentOpenDrawer.contains(event.target) && !event.target.classList.contains('drawer-only')) {
                closeDrawerOnly(currentOpenDrawer);
            }
        });

        // Close drawer when pressing Enter or Space outside
        document.addEventListener('keydown', function(e) {
            if (currentOpenDrawer && ((e.key === 'Enter' || e.keyCode === 13) || (e.key === 'Space' || e.keyCode === 32))) {
                var activeElement = document.activeElement;
                if (!currentOpenDrawer.contains(activeElement) && !activeElement.classList.contains('drawer-only')) {
                    closeDrawerOnly(currentOpenDrawer);
                }
            }
        });
    }
    // Function to handle close buttons inside nested drawers
    function handleNestedDrawerCloseButtons() {
        var nestedDrawers = document.querySelectorAll('.drawer.drawer-nested');
        var megaNav = document.querySelector('#mega-nav');

        for (var i = 0; i < nestedDrawers.length; i++) {
            (function(drawer) {
                var closeButton = drawer.querySelector('.drawer-close.close-main-drawer');
                var backButton = drawer.querySelector('.drawer-back');
                var parentDrawer = drawer;

                if (closeButton) {
                    closeButton.addEventListener('keydown', function(e) {
                        if ((e.key === 'Enter' || e.keyCode === 13) || (e.key === 'Space' || e.keyCode === 32)) {
                            e.preventDefault();
                            var closestDrawer = findClosest(this, '.drawer.drawer-nested');
                            if (closestDrawer) {
                                closestDrawer.classList.remove('open');
                                closestDrawer.style.display = "none";
                                closestDrawer.ariaHidden = "true";
                            }
                            this.click(); // Simulate a click on the button
                        }
                    });

                    closeButton.addEventListener('click', function() {
                        var closestDrawer = findClosest(this, '.drawer.drawer-nested');
                        var fallbackTarget = getPrimaryTriggerFromDrawer(closestDrawer);
                        setTimeout(updateFocusTrapTarget, 0);
                        setTimeout(function() {
                            focusLastTriggerOrDrawer(fallbackTarget);
                        }, 0);
                    });

                    // Ensure the button is focusable
                    if (!closeButton.getAttribute('tabindex')) {
                        closeButton.setAttribute('tabindex', '0');
                    }

                    // Add aria-label if not present
                    if (!closeButton.getAttribute('aria-label')) {
                        closeButton.setAttribute('aria-label', 'Close drawer');
                    }
                }
                if (backButton) {
                    backButton.addEventListener('keydown', function(e) {
                        if ((e.key === 'Enter' || e.keyCode === 13) || (e.key === 'Space' || e.keyCode === 32)) {
                            e.preventDefault();
                            this.click(); // Simulate a click on the button
                        }
                    });

                    backButton.addEventListener('click', function() {
                        var closestDrawer = findClosest(this, '.drawer.drawer-nested');
                        var fallbackTarget = getPrimaryTriggerFromDrawer(closestDrawer);
                        setTimeout(updateFocusTrapTarget, 0);
                        setTimeout(function() {
                            focusLastTriggerOrDrawer(fallbackTarget);
                        }, 0);
                    });

                    // Ensure the button is focusable
                    if (!backButton.getAttribute('tabindex')) {
                        backButton.setAttribute('tabindex', '0');
                    }

                    // Add aria-label if not present
                    if (!backButton.getAttribute('aria-label')) {
                        backButton.setAttribute('aria-label', 'Back to main menu');
                    }
                }
            })(nestedDrawers[i]);
        }
    }

    //Add events
    addEventsToMenuItems(accordionBodies);
    addEventsToMenuItems(drawerOnlyBody);

    // Call the function to initialize the nested drawer close buttons
    handleNestedDrawerCloseButtons();
    handleMainDrawerCloseButtons();
    registerNestedDrawerTriggerTracking();
    initNestedDrawerObserver();

    // Call the function to initialize the special sections
    drawerOnlyNavs();
}

//Don't fire this until we have navigation
window.domUtils.waitForElement('.drawer-body', accessibilityHelpers.init);